import { render, staticRenderFns } from "./surveylayout.vue?vue&type=template&id=2dd75c6e&scoped=true"
import script from "./surveylayout.vue?vue&type=script&lang=js"
export * from "./surveylayout.vue?vue&type=script&lang=js"
import style0 from "./surveylayout.vue?vue&type=style&index=0&id=2dd75c6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_sniwsisxdvcgzet3yrvlfqnueq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd75c6e",
  null
  
)

export default component.exports